import React from "react"
import "../../style/helper.css";
import LoadingCircle from './loading-circle.png';

class LoadingScreen extends React.Component {

    render() {
        return(
            <div className="page-main">
                <div className="page-content-loading">
                    <img className="loading-image" src={LoadingCircle} width="75" height="75"/>
                </div>
            </div>
        )
    }
    
}

export default LoadingScreen;